<ion-grid>
	<ion-row>
		<ion-col size="12" class="Body_M_highlights main-title">
			{{ title }}
		</ion-col>
		<ion-col size="12" class="Body_S" [innerHtml]="subTitle"> </ion-col>
		<ion-col size="12" class="buttons">
			<ion-button class="Large-Button-Active_primary pr16" (click)="withdraw()">
				<span *ngIf="buttonText === ''">Yes, Delete</span>
				<span *ngIf="buttonText !== ''">{{ buttonText }}</span>
			</ion-button>
			<ion-button class="Large-Button-Active_secondary" (click)="cancel()">
				<span>Cancel</span>
			</ion-button>
		</ion-col>
	</ion-row>
</ion-grid>
